


























import Vue from 'vue'

import signinbtn  from '@/components/btn-signin.vue';
import avatar     from '@/components/users/avatar.vue';
import Dropdown   from '@/components/app/dropdown.vue';
import Breadcrumbs  from '@/components/app/breadcrumbs_mobile.vue';

export default Vue.extend({
  data() {
    return {
      showModal: false,
      dropOptions: [
        
      ],
      showDropdown: false,
    }
  },
  methods: {
    dropSelected(payload) {
      console.log(payload.id)
    },
    toggleSidebar() {
      document.getElementById("sidebar").classList.toggle("hide-on-med-and-down");
      document.getElementById("sidebar").style.zIndex = "100";
    }
  },
  components: {
    'sign-in-btn': signinbtn,
    avatar: avatar,
    'dropdown-menu': Dropdown,
    Breadcrumbs,
  },
});
